import { render, staticRenderFns } from "./DeleteRow.vue?vue&type=template&id=a3dd28e4&scoped=true"
import script from "./DeleteRow.vue?vue&type=script&lang=js"
export * from "./DeleteRow.vue?vue&type=script&lang=js"
import style0 from "./DeleteRow.vue?vue&type=style&index=0&id=a3dd28e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dd28e4",
  null
  
)

export default component.exports